import { render } from "./ActorList.vue?vue&type=template&id=2d468c84&scoped=true&lang=pug"
import script from "./ActorList.vue?vue&type=script&lang=js"
export * from "./ActorList.vue?vue&type=script&lang=js"

import "./ActorList.vue?vue&type=style&index=0&id=2d468c84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d468c84"]])

export default __exports__